import { FormattedMessage, injectIntl } from 'react-intl';
import React, {
  useState,
  useEffect,
  useRef,
  useContext,
  createRef,
} from 'react';
import { getUrlParams, getUrlPrefix, reportEventToMonitor } from '@/utils/index.js';
import myContext from '@/utils/createContext';
import { paymentCashier3dsDevicePayflow } from '@/components/H5PC/service';
import { paySuccussHref, CommonError } from '@/components/H5PC/CommonMethod';
// 渠道返回 和 自己系统返回的区别 !important 有助于理解
function Tds(props) {
  const intl = props.intl;
  const {
    isMobileView,
    key,
    resData,
    payflowRes,
    type,
    setLoading,
    checkPolling
  } = useContext(myContext);
  const btnRef = useRef();
  // const btnRef = createRef();
  let [myUrl, setMyUrl] = useState('');
  const [myMethod, setMyMethod] = useState('');
  const [myBody, setMyBody] = useState('');
  const [myNextStep, setMyNextStep] = useState('');

  // 以下参数暂时未使用到
  const [myHeader, setMyHeader] = useState('');
  const [myVersion, setMyVersion] = useState('');
  const [myOperation, setMyOperation] = useState('');

  // 设备相关
  const [deviceWaitRetryTime, setDeviceWaitRetryTime] = useState(1000);

  useEffect(() => {
    fetchData();
  }, [payflowRes]);

  const submitForm = function() {
    if (btnRef.current) {
      btnRef.current.click();
    }
  };

  const fetchData = function() {
    const res = payflowRes;
    if (res && res.code === 200000) {
      // 清除refreshTimes的次数，使得跳出后跳回来也是第一次提醒错误
      window.sessionStorage.removeItem('refreshTimes');
      // 清除新增卡标记
      // process.client && window.sessionStorage.removeItem('addNewCard');
      //todo 判断3ds页面和非3ds页面逻辑区别
      const tdsKey = res.data.tdsKey;
      const tdsInfo = res.data.tdsInfo || {};
      console.log('tdsInfo', tdsInfo);
      const { nextStep, url } = tdsInfo;
      // let validateKey = res?.data?.validateKey;
      // console.log('tdskey',tdsKey);
      if (tdsKey && !_.isEmpty(tdsInfo)) {
        setObjValue(tdsInfo);
        if (nextStep === 'DEVICE') {
          // 提交设备指纹iframe表单;
          setTimeout(() => {
            submitForm();
            // 一般情况下，返回的时间需要计算一下。
          }, 200);

          setTimeout(() => {
            fetchDeviceFingerPrint(tdsKey);
          }, 500);
        } else if (nextStep === 'CHALLENGE') {
          window.location.href = `/3ds?tdsKey=${tdsKey}`;
        } else if (nextStep === 'DONE') {
          window.location.href = url;
        }
      } else { 
          // 长轮询
          checkPolling()
      }
    }
  };

  // let interval;
  // 风控指纹轮询
  const startFetch = _tdsKey => {
    setTimeout(function() {
      fetchDeviceFingerPrint(_tdsKey);
    }, deviceWaitRetryTime);
  };

  const redirectUrlFn = redirectUrl => {
    const urlPrefix = getUrlPrefix();
    if (redirectUrl) {
      if (redirectUrl.indexOf('http') > -1) {
        window.location.href = redirectUrl;
      } else {
        window.location.href = `${urlPrefix}${redirectUrl}`;
      }
    }
  };

  const fetchDeviceFingerPrint = async _tdsKey => {
    const res = await paymentCashier3dsDevicePayflow(_tdsKey);
    let { code, data } = res || {};
    let {
      paymentStatus,
      redirectUrl,
      tdsKey,
      tdsInfo,
      waitRetryTime,
      invoiceId,
    } = data || {};
    console.log('payment3dsDevicePayflow', data);
    console.log('redirectUrl', redirectUrl);
    // 第一看paymentStatus，第二看tdsKey，waitRetryTime只有在code为400005才用到
    // 优先级：
    // code=wait_retry：则等待waitRetryTime毫秒后重试
    // code=SUCCESSpaymentSuccess=true，则走支付成功逻辑
    // tdsKey不为空，则根据tdsInfo 走下一步挑战
    // 否则，跳转redirectUrl
    // 所以paymentSuccss>tdsKey>其他情况
    if (code === 200000) {
      // 如果支付成功，则直接跳转页面
      if (paymentStatus === 'PS') {
        // clearInterval(interval);
        // redirectUrlFn(redirectUrl);
        paySuccussHref(redirectUrl, invoiceId, resData, type, key, res);
        // console.log(res);
      } else if (paymentStatus === 'PP') {
        // 支付状态为PP，即支付处理中，则继续轮询，查询订单状态
        checkPolling();
      } else if (paymentStatus === 'PF') {
        
        let returnData = res.data;
        const useData = {
          code: returnData?.declineCode || '',
          message: returnData?.errorMessage || '',
          ...returnData
        }

        CommonError(props, isMobileView, setLoading, useData);
      }  else if (tdsKey && !_.isEmpty(tdsInfo)) {
        if (tdsInfo?.nextStep === 'DONE') {
          checkPolling();
        } else {
          // clearInterval(interval);
          setObjValue(tdsInfo);
          // 提交挑战表单;
          submitForm();
        }
      } else { 
        // 设备指纹告警
        reportEventToMonitor(`设备指纹报警(cashier_tds): 设备指纹接口url=/payment/cashier/3ds/devicePayflow/${key};`)

        // 订单接口轮询
        checkPolling();
        
      }
      // redirectUrlFn(redirectUrl);
    } else if (code === 400005) {
      // clearInterval(interval);
      setDeviceWaitRetryTime(waitRetryTime);
      startFetch(_tdsKey);
    } else {
      // clearInterval(interval);
      CommonError(props, isMobileView, setLoading, res);
    }
  };

  // 统一设置从后端获取到的obj对象
  const setObjValue = obj => {
    const { url, method, body, header, version, nextStep, opration } =
      obj || {};
    setMyUrl(url);
    setMyMethod(method);
    setMyBody(body);
    setMyHeader(header);
    setMyVersion(version);
    setMyNextStep(nextStep);
    setMyOperation(opration);
  };

  // 动态构建表单
  const dynamicForm = function(type) {
    // 动态生成表单数据
    // const body = { c: 'cc', d: 'dd' };
    let myBodyArry = [];
    for (let obj in myBody) {
      myBodyArry.push(obj);
    }

    let target;
    if (type === 'DEVICE') {
      target = 'device_form_iframe';
    } else {
      target = '_self';
    }

    let html = (
      <form
        action={myUrl}
        method={myMethod}
        target={target}
        style={{ display: 'none' }}
      >
        {myBodyArry.map(val => {
          return (
            <input
              type="text"
              key={val}
              defaultValue={myBody[val]}
              name={val}
            />
          );
        })}
        <input type="submit" value="Submit" ref={btnRef} />
      </form>
    );
    return html;
  };

  return (
    <div className="body-container-next-step">
      {myNextStep === 'CHALLENGE' ? dynamicForm() : null}
      {myNextStep === 'DEVICE' ? (
        <>
          {dynamicForm('DEVICE')}
          <iframe
            name="device_form_iframe"
            style={{ display: 'none' }}
          ></iframe>
        </>
      ) : null}
    </div>
  );
}

export default injectIntl(Tds);
